import { RawPageModel } from "../page_model.js";

class RawAdminPageModel extends RawPageModel {

}
const AdminPageModel = new RawAdminPageModel();

export { RawAdminPageModel, AdminPageModel }

